<ng-container [formGroup]="form">
  <ix-fieldset [title]="'Authentication' | translate">
    <ix-input
      formControlName="access_key_id"
      [label]="'Access Key ID' | translate"
      [required]="true"
      [tooltip]="helptext.access_key_id_s3.tooltip | translate"
    ></ix-input>

    <ix-input
      formControlName="secret_access_key"
      type="password"
      [label]="'Secret Access Key' | translate"
      [required]="true"
      [tooltip]="helptext.secret_access_key_s3.tooltip | translate"
    ></ix-input>
  </ix-fieldset>

  <ix-fieldset [title]="'Advanced Options' | translate">
    <ix-input
      formControlName="max_upload_parts"
      type="number"
      [label]="'Maximum Upload Parts' | translate"
      [tooltip]="helptext.max_upload_parts_s3.tooltip | translate"
    ></ix-input>

    <ix-input
      formControlName="endpoint"
      [label]="'Endpoint URL' | translate"
      [tooltip]="helptext.endpoint_s3.tooltip | translate"
    ></ix-input>

    <ix-input
      formControlName="region"
      [label]="'Region' | translate"
      [tooltip]="helptext.region_s3.tooltip | translate"
    ></ix-input>

    <ix-checkbox
      formControlName="skip_region"
      [label]="'Disable Endpoint Region' | translate"
      [tooltip]="helptext.skip_region_s3.tooltip | translate"
    ></ix-checkbox>

    <ix-checkbox
      formControlName="signatures_v2"
      [label]="'Use Signature Version 2' | translate"
      [tooltip]="helptext.signatures_v2_s3.tooltip | translate"
    ></ix-checkbox>
  </ix-fieldset>
</ng-container>
